import { AxiosResponse } from 'axios';
import ApiService, { ApiArguments } from '@/api/api_service';

import {
  NextActionSuggestionApiPostNextActionSuggestionApproveRequest,
  NextActionSuggestionApiPostNextActionSuggestionRejectRequest,
  GetNextActionSuggestions200Response,
  NextActionSuggestionApiGetNextActionSuggestionsRequest,
  NextActionSuggestionApi,
} from '@/api/openapi';

export class NextActionSuggestionApiService extends ApiService {
  api = new NextActionSuggestionApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async postNextActionSuggestionApprove({
    request,
    options,
    errorHandlers,
  }: ApiArguments<NextActionSuggestionApiPostNextActionSuggestionApproveRequest>): Promise<AxiosResponse<void>> {
    return this.checkResponse<void>(
      this.api.postNextActionSuggestionApprove(request, options),
      errorHandlers,
    );
  }

  async postNextActionSuggestionReject({
    request,
    options,
    errorHandlers,
  }: ApiArguments<NextActionSuggestionApiPostNextActionSuggestionRejectRequest>): Promise<AxiosResponse<void>> {
    return this.checkResponse<void>(
      this.api.postNextActionSuggestionReject(request, options),
      errorHandlers,
    );
  }

  async getNextActionSuggestions({
    request,
    options,
    errorHandlers,
  }: ApiArguments<NextActionSuggestionApiGetNextActionSuggestionsRequest>): Promise<AxiosResponse<GetNextActionSuggestions200Response>> {
    return this.checkResponse<GetNextActionSuggestions200Response>(
      this.api.getNextActionSuggestions(request, options),
      errorHandlers,
    );
  }
}
